(() => {
  const CACHE = new Map();

  const getTarget = () => document.querySelector('.collection-tabs-target');

  const getHeroHeading = (root) => root.querySelector('.media-banner-section:first-child .media-banner__heading');

  const getHeroImage = (root, variant) => {
    if (variant === 'desktop') {
      return (
        root.querySelector('.media-banner-section:first-child .media-banner__image--desktop') ||
        root.querySelector('.media-banner-section:first-child .media-banner__image:not(.media-banner__image--mobile)')
      );
    }
    return root.querySelector('.media-banner-section:first-child .media-banner__image--mobile');
  };

  const extractHeroData = (root) => {
    const heading = getHeroHeading(root);
    const imgDesktop = getHeroImage(root, 'desktop');
    const imgMobile = getHeroImage(root, 'mobile');

    const imageAttrs = (img) =>
      img
        ? {
            src: img.getAttribute('src'),
            srcset: img.getAttribute('srcset'),
            sizes: img.getAttribute('sizes'),
            alt: img.getAttribute('alt'),
          }
        : null;

    return {
      headingHTML: heading ? heading.innerHTML : null,
      desktop: imageAttrs(imgDesktop),
      mobile: imageAttrs(imgMobile),
    };
  };

  const applyHeroData = (hero) => {
    if (!hero) return;

    if (hero.headingHTML != null) {
      const heading = getHeroHeading(document);
      if (heading) heading.innerHTML = hero.headingHTML;
    }

    const applyImage = (img, attrs) => {
      if (!img || !attrs) return;
      if (attrs.src != null) img.setAttribute('src', attrs.src);
      if (attrs.srcset != null) img.setAttribute('srcset', attrs.srcset);
      if (attrs.sizes != null) img.setAttribute('sizes', attrs.sizes);
      if (attrs.alt != null) img.setAttribute('alt', attrs.alt);
    };

    applyImage(getHeroImage(document, 'desktop'), hero.desktop);
    applyImage(getHeroImage(document, 'mobile'), hero.mobile);
  };

  const reinitGrid = () => {
    const target = getTarget();
    if (target) {
      target.querySelectorAll('.observe-me').forEach((el) => el.classList.remove('observe-me'));
    }

    if (typeof initFacetsSwiper === 'function') initFacetsSwiper();
    if (typeof colorSwatches === 'function') colorSwatches();

    if (typeof Swiper !== 'undefined') {
      document.querySelectorAll('.product-card-js').forEach((slider) => {
        new Swiper(slider, {
          pagination: {
            el: '.product-pagination .swiper-pagination',
            type: 'progressbar',
          },
          navigation: {
            nextEl: '.product-button-group .swiper-button-next',
            prevEl: '.product-button-group .swiper-button-prev',
          },
          allowTouchMove: true,
          breakpoints: {
            990: { allowTouchMove: false },
          },
        });
      });
    }

    if (
      typeof loadMore === 'function' &&
      (document.querySelector('.js-load-more') || document.querySelector('.js-infinite-scroll'))
    ) {
      loadMore();
    }
  };

  const applyHTML = (entry) => {
    const target = getTarget();
    if (!target || !entry) return;
    target.innerHTML = entry.gridHTML;
    applyHeroData(entry.hero);
    reinitGrid();
    target.setAttribute('role', 'tabpanel');
    target.setAttribute('tabindex', '-1');
    announceStatusRefresh();
  };

  // #FacetsStatus is inside the swapped region, so it's a brand-new element
  // after target.innerHTML above (not a mutation of the one AT was already
  // watching) - most screen readers won't announce that on its own. Re-set
  // its own text on the next tick so it fires as a live-region update.
  const announceStatusRefresh = () => {
    const status = document.getElementById('FacetsStatus');
    if (!status) return;
    const text = status.textContent;
    status.textContent = '';
    requestAnimationFrame(() => {
      status.textContent = text;
    });
  };

  const setActiveTab = (button) => {
    document.querySelectorAll('[data-collection-tab]').forEach((tab) => {
      const isActive = tab === button;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    const panel = getTarget();
    if (panel && button.id) {
      panel.setAttribute('aria-labelledby', button.id);
    }
  };

  const cacheKeyFor = (button) =>
    button.dataset.mode === 'browse'
      ? `browse:${button.dataset.blockId}`
      : `collection:${button.dataset.handle}`;

  const seedInitialCache = () => {
    const target = getTarget();
    const activeButton = document.querySelector('[data-collection-tab].is-active');
    if (!target || !activeButton) return;

    target.setAttribute('role', 'tabpanel');
    target.setAttribute('tabindex', '-1');
    if (activeButton.id) target.setAttribute('aria-labelledby', activeButton.id);

    const key = cacheKeyFor(activeButton);
    if (!CACHE.has(key)) {
      CACHE.set(key, { gridHTML: target.innerHTML, hero: extractHeroData(document) });
    }
  };

  const focusTab = (button) => {
    button.focus();
    onTabClick(button);
  };

  const initKeyboardNav = () => {
    const tablist = document.querySelector('.collection-tabs__list[role="tablist"]');
    if (!tablist) return;

    tablist.addEventListener('keydown', (event) => {
      const tabs = Array.from(tablist.querySelectorAll('[data-collection-tab]'));
      const currentIndex = tabs.indexOf(document.activeElement);
      if (currentIndex === -1) return;

      let nextIndex = null;
      if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % tabs.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = tabs.length - 1;
      }

      if (nextIndex === null) return;
      event.preventDefault();
      focusTab(tabs[nextIndex]);
    });
  };

  const fetchCollectionHTML = (handle) => {
    const url = `/collections/${handle}`;
    return fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const parsed = new DOMParser().parseFromString(responseText, 'text/html');
        const source = parsed.querySelector('.collection-tabs-target');
        if (!source) return null;
        return { gridHTML: source.innerHTML, hero: extractHeroData(parsed) };
      });
  };

  const getBrowsePanelHTML = (blockId) => {
    const template = document.querySelector(
      `template[data-collection-tabs-panel][data-block-id="${blockId}"]`
    );
    return template ? { gridHTML: template.innerHTML, hero: null } : null;
  };

  const onTabClick = (button) => {
    if (button.classList.contains('is-active')) return;

    setActiveTab(button);

    const key = cacheKeyFor(button);
    if (CACHE.has(key)) {
      applyHTML(CACHE.get(key));
      return;
    }

    const target = getTarget();
    if (target) target.classList.add('is-loading');

    const pending =
      button.dataset.mode === 'browse'
        ? Promise.resolve(getBrowsePanelHTML(button.dataset.blockId))
        : fetchCollectionHTML(button.dataset.handle);

    pending
      .then((entry) => {
        if (!entry) return;
        CACHE.set(key, entry);
        applyHTML(entry);
      })
      .finally(() => {
        if (target) target.classList.remove('is-loading');
      });
  };

  document.addEventListener('DOMContentLoaded', () => {
    seedInitialCache();
    initKeyboardNav();
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-collection-tab]');
    if (!button) return;
    onTabClick(button);
  });
})();
